import React from 'react'
import Layout from '../components/Layout/Layout'
const Contact = () => {
  return (
    <Layout>Contact</Layout>
  )
}

export default Contact